import { createContext } from "react";

export const LanguageContext: any = createContext<any>(null);